import React from 'react';
import SelectDivision from '../../selectores/SelectDivision.js';

const CampoComboDivision = (props) => {
  const nombre = props.nombre;
  const valor = props.valor;
  const editar = props.editar;
  const idPais = props.idPais;
  const incluirNulo = props.incluirNulo !== false;
  const estilo = props.estilo;

  const onDivisionElegida = (divisionElegida) => {
    props.onChange(nombre, divisionElegida);
  };

  let campo = '';
  if (editar) {
    campo = (
      <SelectDivision
        divisionActual={valor}
        idPais={idPais}
        incluirNulo={incluirNulo}
        estilo={estilo}
        onDivisionElegida={onDivisionElegida}
      />
    );
  } else {
    campo = valor ? valor.descripcion : '';
  }

  return <React.Fragment>{campo}</React.Fragment>;
};

export default CampoComboDivision;
